<template>
  <StyledDiv
    minWidth="100px"
    maxWidth="150px"
    minHeight="200px"
    justifyContent="space-between"
    class="singleChild"
    :class="
      number === 1 ? 'butOnlyWrap' : number === 0 ? 'firstChildWrap' : null
    "
  >
    <StyledImage
      v-if="info.pic"
      :src="info.pic"
      maxWidth="120px"
      minHeight="120px"
      class="childImage"
    />
    <StyledText
      :fontSize="styled('fontSize-medium')"
      :color="styled('pdfPink')"
      v-if="info.pic"
      :mobileFontSize="styled('fontSize-mediumSmall')"
      >{{ info.percent }}</StyledText
    >
    <StyledText
      :fontFamily="styled('fontFamily-GothamMedium')"
      padding="0"
      margin="0"
      v-if="info.pic"
      >{{ info.nationality }}</StyledText
    >
    <StyledText
      padding="0"
      margin="auto 0"
      v-if="!info.pic"
      :fontFamily="styled('fontFamily-GothamMedium')"
      class="butOnlyText"
      >but only</StyledText
    >
  </StyledDiv>
</template>

<script>
import { StyledDiv, StyledText, StyledImage } from "../styled";
import StyleCompiler from "../styled/StyleCompiler";
export default {
  props: ["info", "number"],
  components: {
    StyledDiv,
    StyledText,
    StyledImage
  },
  methods: {
    styled(e) {
      return StyleCompiler(e);
    }
  }
};
</script>

<style>
@media (max-width: 800px) {
  .childImage {
    max-width: 80px;
    min-height: unset;
  }
  .singleChild {
    min-height: 150px;
    max-width: 100px;
    margin: 0 3px;
  }
}
@media (max-width: 560px) {
  .childImage {
    max-width: 55px;
  }
  .singleChild {
    min-width: unset;
    max-width: unset;
    width: initial;
  }
  .butOnlyText {
    margin: auto 10px;
    font-style: italic;
  }
}
@media (max-width: 500px) {
  .singleChild {
    margin: 20px 3px;
  }
  .butOnlyWrap {
    margin-right: 25%;
  }
  .firstChildWrap {
    margin-left: 25%;
  }
}
@media (max-width: 400px) {
  .butOnlyWrap {
    margin-right: 20%;
  }
  .firstChildWrap {
    margin-left: 20%;
  }
}
@media (max-width: 301px) {
  .butOnlyWrap {
    margin-right: 10%;
  }
  .firstChildWrap {
    margin-left: 10%;
  }
}
</style>
